import { Injectable } from '@angular/core';
import { User } from "../models/UserObj";
import { CookieService } from 'ngx-cookie';
import { LocalStorageService } from 'angular-2-local-storage';
import * as moment from 'moment';
import { environment } from '../../environments/environment';
import { appSettings } from '../settings/constants';
import { UserPreference } from '../models/UserPreference';
import * as _ from 'lodash';

@Injectable()
export class CommonService {

  currentUser: User = null;
  objUser: User = null;
  lastUpdatedTime: Date;

  constructor(private _cookieService: CookieService,
    private _localStorageService: LocalStorageService) { }

  UserDetail(data: any): User {
    if (data) {
      this.objUser = new User();
      this.objUser.UserId = data.User.UserId;
      this.objUser.UserName = data.User.UserName;
      this.objUser.ForcePasswordReset = data.User.ForcePasswordReset;
      this.objUser.IsOhlEmployee = data.User.IsOhlEmployee;
      this.objUser.FirstName = data.User.FirstName;
      this.objUser.LastName = data.User.LastName;
      this.objUser.Email = data.User.Email;
      this.objUser.IsPortalUser = data.User.IsPortalUser;

      this.objUser.Status = data.Status;
      this.objUser.Token = data.Token;
      //console.log(this.objUser);
      return this.objUser;
    }
    else
      return null;

  }

  setUser(status: any): void {
    this.currentUser = this.UserDetail(status);
    if (!this.currentUser || !this.currentUser.Status || this.currentUser.Token === '') {
      this._cookieService.removeAll()
    } else {
      this._cookieService.remove(appSettings.LoginCookieName)
      let expDate = new Date();
      expDate.setDate(expDate.getDate() + parseInt(environment.CookieExpirationTime));
      this._cookieService.putObject(appSettings.LoginCookieName, this.currentUser, { 'expires': expDate });

      if (status.User.UserAccessLevels) {
        this.setUserAccessLevels(status.User.UserAccessLevels);
      }

      if (status.User.EULA) {
        this._localStorageService.set('EULA', status.User.EULA);
      }
    }
  }

  getUser() {
    if (this._cookieService.getObject(appSettings.LoginCookieName) === undefined) {
      this.currentUser = null;
    } else if (this.currentUser === null) {
      this.currentUser = <User>this._cookieService.getObject(appSettings.LoginCookieName);
    }

    if (this.currentUser) {
      this.currentUser.UserAccessLevels = this.getUserAccessLevels();
      this.currentUser.EULA = this._localStorageService.get("EULA");
    }

    return this.currentUser;
  }

  getUserAccessLevels(): any {
    let accessLevels = this._localStorageService.get('useraccesslevels');
    return accessLevels ? accessLevels : [];
  }

  setUserAccessLevels(useraccesslevels: any) {
    this._localStorageService.set('useraccesslevels', useraccesslevels);
  }

  getAccessLevel(accessGroupKey: any): any {
    let accessLevels: any = this.getUserAccessLevels();
    let filteredAccessLevels = accessLevels.filter(x => x.AccessGroupKey == accessGroupKey);
    if (filteredAccessLevels && filteredAccessLevels.length > 0) {
      return filteredAccessLevels[0];
    }
    else
      return null;
  }

  percentage(num, total) {
    return Math.round((num / total) * 100);
  }

  getTimeDiff(inputTime) {
    let timeLine = inputTime.split('\n');
    if (timeLine && timeLine.length > 0) {
      inputTime = timeLine[0];
    }
    let endTime = new Date();
    let timeParts = inputTime.split(":");
    let pushTimeInMs = (timeParts[0] * (60000 * 60)) + (timeParts[1] * 60000);

    let currentDate = new Date();
    let currentTimeInMs = (currentDate.getHours() * (60000 * 60)) + (currentDate.getMinutes() * 60000);

    let timeRemaining = pushTimeInMs - currentTimeInMs;
    let minutes = (timeRemaining / (1000 * 60)) % 60
    let hours = (timeRemaining / (1000 * 60 * 60)) % 24
    if (Math.round(minutes) == 60) {
      hours = hours + 1;
      return Math.round(hours) + 'hrs\n' + Math.round(minutes) + 'min';
    } else {
      return Math.round(hours) + 'hrs\n' + Math.round(minutes) + 'min';
    }
  }

  getTimeDiffFormatter(params) {
    let inputTime: string = params.data.pulltime;
    //console.log('getTimeDiffFormatter', params);
    let timeLine = inputTime.split('\n');
    if (timeLine && timeLine.length > 0) {
      inputTime = timeLine[0];
    }
    let endTime = new Date();
    let timeParts: Array<any> = inputTime.split(":");
    let pushTimeInMs = (timeParts[0] * (60000 * 60)) + (timeParts[1] * 60000);

    let currentDate = new Date();
    let currentTimeInMs = (currentDate.getHours() * (60000 * 60)) + (currentDate.getMinutes() * 60000);

    let timeRemaining = pushTimeInMs - currentTimeInMs;
    let minutes = (timeRemaining / (1000 * 60)) % 60
    let hours = (timeRemaining / (1000 * 60 * 60)) % 24
    if (Math.round(minutes) == 60) {
      hours = hours + 1;
      return Math.round(hours) + 'hrs\n' + Math.round(minutes) + 'min';
    } else {
      return Math.round(hours) + 'hrs\n' + Math.round(minutes) + 'min';
    }
  }

  convertData(ordervalue, unitvalue, totalorders, totalunits) {
    // console.log(ordervalue + '  ' + unitvalue + '  ' + totalorders + '  ' + totalunits);
    let res = [];
    let tmpOrderVal = 0;
    if (!isNaN(ordervalue))
      tmpOrderVal = ((ordervalue / totalorders) * 100);

    let tmpUnitVal = 0;
    if (!isNaN(unitvalue))
      tmpUnitVal = ((unitvalue / totalunits) * 100);

    if (isNaN(tmpOrderVal))
      tmpOrderVal = 0;
    if (isNaN(tmpUnitVal))
      tmpUnitVal = 0;

    res.push({
      value: tmpUnitVal,
      order: unitvalue
    });

    res.push({
      value: tmpOrderVal,
      order: ordervalue
    });

    return res;
  }

  setUserPreference(preference: UserPreference) {
    sessionStorage.setItem('userPreference', JSON.stringify(preference));
  }

  getUserPreference(): UserPreference {
    let preference: UserPreference;
    preference = JSON.parse(sessionStorage.getItem('userPreference'));
    return preference;
  }

  unique(value, index, self): any {
    return self.indexOf(value) === index;
  }

  shallowClone(source: any): any {
    return Object.assign({}, source);
  }

  deepClone(source: any): any {
    //return JSON.parse(JSON.stringify(source));
    let copy: any;
    copy = _.clone(source); //lodash clone
    return copy;
  }

  formatDate(dateTime: Date, formatString: string): string {
    if (dateTime) {
      let tDate = moment(dateTime);
      return tDate.format(formatString);
    }
    else {
      return '';
    }
  }

  sortArray(data: any[], property:any){
    data.sort(function (a, b) {
      if (a[property] < b[property])
        return -1;
        if (a[property] > b[property])
        return 1;
      return 0;
    });
    return data;
  }

  getColorCodes(){
    return [{status:'RELEASED',color:'#29ABE2'},{status:'PROCESSED INTO WALL',color:'#44BD54'},
      {status:'BATCH PICKED',color:'#E3ED74'},{status:'STAGED',color:'#8CC63F'},
      {status:'SHIPPED',color:'#DFB45A'},{status:'PARTIALLY SORTED',color:'#F4F4F4'},
      {status:'FULLY SORTED',color:'#9AD945'},{status:'CUBBIES EMPTY',color:'#00FA9A'},
      {status:'LINE SHORTED',color:'#8B0000'}];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts